module.exports = __webpack_public_path__ + "58bed8b7bc677c3a35a01823babbfe3f.pdf";